import { FC } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import theme from 'theme'

/* Utils */
import { PerformanceScoreCategoryDetailsDataSources, CategoryActivityItem } from '../../../../../../models'

/* Components */
import { CategoryWrapper, EmptyDataCategoryWrapper } from './category.styles'
import DataSources from './DataSources'
import { ChipTooltip } from '../../../../../components/tooltip/ChipTooltip'

interface Props {
  category: CategoryActivityItem
  handleCategoryClick: (category: string) => void
  dataSources: PerformanceScoreCategoryDetailsDataSources[]
  ishovered?: string
  minWidth?: string
}

const InitializingCategory: FC<Props> = ({ category, handleCategoryClick, dataSources, ishovered, minWidth }) => (
  <CategoryWrapper
    className="initializing-category-wrapper"
    titlelength={category.name.length}
    ishovered={ishovered}
    sx={{ minWidth }}
  >
    <Box className="header" onClick={() => handleCategoryClick(category.name)}>
      <ChipTooltip
        PopperProps={{
          sx: {
            marginTop: `-${theme.spacing.sm}px !important`
          }
        }}
        title={
          <Box className="tooltip-wrapper-permissions one-line">
            <Typography className="tooltip-text">{category.name}</Typography>
          </Box>
        }
      >
        <Typography className="category-title category-margin">{category.name}</Typography>
      </ChipTooltip>
    </Box>

    <EmptyDataCategoryWrapper>
      <Box className="scale">
        <Typography className="scale-text">100%</Typography>
        <Typography className="scale-text">50%</Typography>
        <Typography className="scale-text">0%</Typography>
      </Box>

      <Box
        className="chart-button-wrapper"
        sx={{ background: `${theme.colors.initializingCardBg} !important`, gap: `${theme.spacing.xSmall}px` }}
      >
        <CircularProgress
          size={16}
          sx={{
            color: '#D0C3CC',
            "html[data-theme='light'] &": {
              color: theme.colors.menuItemText
            }
          }}
        />
        <Typography className="initializing-text">Initializing</Typography>
      </Box>
    </EmptyDataCategoryWrapper>
    <DataSources dataSources={dataSources} />
  </CategoryWrapper>
)

export default InitializingCategory
